import { Directive, Input } from '@angular/core';

@Directive()
export abstract class AbstractTailoredTemplateWidget<T extends {}> {
    @Input() config!: T;
}
